import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSearchParams } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useMemoizedFn } from 'ahooks';
import { v4 as uuidV4 } from 'uuid';
import { HistoryIcon } from 'tdesign-icons-react';
import { scrollBarMixin } from '@/utils/mixinStyle';
import { getAllClusterHistories } from '@/services/clusterService';
import leftPng from './images/left.png';
import trianglePng from './images/triangle.png';
import Item from './Item';

const pageSize = 20;

export default function HistoryPanel({ historyOpen, toggleHistoryOpen, type }) {
  const [searchParams] = useSearchParams();
  const [loading, setloading] = useState(false);
  const [histories, setHistories] = useState([]);
  const [dataLength, setDataLength] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const clusterName = searchParams.get('name');

  const loadData = useMemoizedFn(async (pageNum) => {
    if (loading) return;
    setCurrentPage(pageNum);
    setloading(true);
    try {
      const {
        data: { items, count },
      } = await getAllClusterHistories({
        clusterType: type,
        startIndex: pageNum,
        pageSize,
        clusterName,
      });

      const itemWithUUID = items.map((item) => ({ ...item, uuid: uuidV4() }));

      setHistories((historieItems) =>
        pageNum === 1 ? itemWithUUID : [...historieItems, ...itemWithUUID],
      );
      setDataLength(count);
      setHasMore(count > pageSize * pageNum);
    } catch (error) {
      console.trace(error);
      throw error;
    } finally {
      setloading(false);
    }
  });

  useEffect(() => {
    loadData(1);
  }, [loadData, clusterName]);

  return (
    <Root $open={historyOpen}>
      <Left>
        <IconContaienr onClick={() => toggleHistoryOpen()} $open={historyOpen}>
          <Icon src={trianglePng} />
        </IconContaienr>
      </Left>
      <Right>
        {historyOpen ? (
          <Container>
            <Title>历史变更记录</Title>
            <ListContaienr id='list-container'>
              <InfiniteScroll
                style={{ overflowX: 'hidden' }}
                scrollableTarget='list-container'
                dataLength={dataLength}
                next={() => loadData(currentPage + 1)}
                hasMore={hasMore}
                loader={<StatusText>加载中...</StatusText>}
                endMessage={<StatusText>已全部加载</StatusText>}
              >
                {histories.map((item, index) => (
                  <Item key={item.uuid} {...item} type={type} isFirst={index === 0} />
                ))}
              </InfiniteScroll>
            </ListContaienr>
          </Container>
        ) : (
          <ShrinkTitle onClick={() => toggleHistoryOpen()}>
            <HistoryIcon fontSize={18} />
            历史
          </ShrinkTitle>
        )}
      </Right>
    </Root>
  );
}

const Root = styled.div`
  position: fixed;
  z-index: 1;
  box-sizing: border-box;
  display: flex;
  transition: 0.4s all cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 268px;
  top: 62px;
  bottom: 0;
  height: ${(props) => (props.$open ? 'auto' : '50px')};
  margin: auto;
  right: ${(props) => (props.$open ? 0 : -208)}px;
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Right = styled.div`
  flex: 1;
  justify-content: center;
  display: flex;
  flex-direction: column;
`;

const IconContaienr = styled.div`
  height: 51px;
  width: 19px;
  padding: 10px 0px 10px 10px;
  margin-right: -3px;
  z-index: 1;
  box-sizing: border-box;
  background-image: url(${leftPng});
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: ${(props) => (!props.$open ? 'hidden' : 'visible')};
`;

const Icon = styled.img`
  width: 6px;
  height: 9px;
  /* transition: 0.4s transform cubic-bezier(0.645, 0.045, 0.355, 1); */
`;

const Title = styled.div`
  color: rgb(13, 17, 26);
  font-size: 16px;
  font-weight: 700;
  line-height: 23px;
  letter-spacing: 0px;
  text-align: left;
  padding-left: 20px;
  padding-top: 20px;
`;

const ListContaienr = styled.div`
  flex: 1;
  height: 0;
  padding: 0 16px 0 20px;
  overflow-y: auto;
  ${scrollBarMixin};
`;

const ShrinkTitle = styled.div`
  width: 48px;
  height: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  cursor: pointer;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  color: #8f959f;
  box-shadow: -1px 0px 4px 0px rgba(0, 0, 0, 0.04);
  font-size: 12px;
  gap: 4px;
  .t-icon {
    color: #bcc0c8;
  }
  &:hover {
    color: #fff;
    .t-icon {
      color: #fff;
    }
    background-color: var(--td-brand-color-7);
  }
`;

const StatusText = styled.div`
  color: rgb(143, 149, 159);
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0px;
  text-align: center;
  margin-bottom: 20px;
`;

const Container = styled.div`
  flex: 1;
  height: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: -1px 0px 4px 0px rgba(0, 0, 0, 0.04);
  background: rgb(255, 255, 255);
`;
